module.exports = __webpack_public_path__ + "img/logo-dark.f6eebf12.svg";